import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Link,
  Typography
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as UnknownErrorIcon } from './icons/Unknown_Error_icon.svg';
import { useErrorPageStyles } from './hooks/useErrorPageStyles';
import { useGoToHome } from './hooks/useGoToHome';

const CONTACT_SUPPORT_LINK =
  'https://www.replicon.com/customerzone/contact-support/';

type ErrorPageProps = {
  open: boolean;
};

const ErrorPage: React.FC<ErrorPageProps> = ({ open }: ErrorPageProps) => {
  const { goToHome } = useGoToHome();
  const classes = useErrorPageStyles();

  return (
    <Dialog open={open} className={classes.root}>
      <DialogContent>
        <div data-testid="error-page">
          <UnknownErrorIcon style={{ fontSize: 40 }} />
          <Typography variant="h2">
            <FormattedMessage id="unhandledErrorPage.title" />
          </Typography>
          <Typography variant="h6">
            <FormattedMessage id="unhandledErrorPage.description" />
          </Typography>
          <Typography variant="body1" data-testid="ecid-container">
            <span>
              <FormattedMessage id="unhandledErrorPage.contactAndSupport" />
            </span>
            <Link
              href={CONTACT_SUPPORT_LINK}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              <FormattedMessage id="notImplementedConnectors.requestSuccess.deltekSupport" />{' '}
            </Link>
            <FormattedMessage id="unhandledErrorPage.assist" />
          </Typography>
        </div>
      </DialogContent>

      <DialogActions className={classes.button}>
        <Button
          color="primary"
          variant="contained"
          onClick={goToHome}
          size="large"
        >
          <FormattedMessage id="unhandledErrorPage.returnHome" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorPage;
